export enum Progress {
  IDLE = 'IDLE',
  WORK = 'WORK',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum Currency {
  CAD = 'CAD',
  EUR = 'EUR',
  RUB = 'RUB',
  USD = 'USD',
  UAH = 'UAH',
}

export type LocalizedValue<T = string> = {
  en?: T
  ru?: T
  fr?: T
  es?: T
  en_US?: T
  es_SV?: T
}

export type ArrayItem<T> = T extends readonly (infer R)[] ? R : never
export type Dict<T> = { [id: string]: T }
export type DictWithKey<T, K extends string | number | symbol = string | number | symbol> = { [id in K]: T }
export type StrictRecord<S, K extends keyof S, T> = {
  [P in K]: T
}
// eslint-disable-next-line prettier/prettier
export type CamelCase<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
  ? `${Lowercase<P1>}${Uppercase<P2>}${CamelCase<P3>}`
  : Lowercase<S>

export type KeysToCamelCase<T> = {
    [K in keyof T as CamelCase<string &K>]: T[K] extends {} ? KeysToCamelCase<T[K]> : T[K]
}